import { useMemo } from 'react';

import { QueryResponse as ComponentListApiResponse } from 'api/queries/getComponentLiteList';

import { WHITELISTED_COMPONENT_KEYS_FOR_AI_NARRATIVE } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/Narrative/EditNarrative/editNarrative';
import { IHashmap } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useComponentListOptions = (componentList: ComponentListApiResponse[] | undefined) => {
    const componentListOptions = useMemo<ISelectOption<string>[]>(
        () =>
            componentList
                ? componentList
                      .filter((item) =>
                          WHITELISTED_COMPONENT_KEYS_FOR_AI_NARRATIVE.includes(item.componentKey as keyof IHashmap),
                      )
                      .map((item) => ({
                          label: item.name,
                          value: item.componentKey,
                          id: item.id,
                      }))
                      .sort((a, b) => a.label.localeCompare(b.label))
                : [],
        [componentList],
    );

    return componentListOptions;
};
